import * as actionTypes from './actionTypes';

import userService from 'services/userService'
import loginService from 'services/loginService'
import objectUtils from 'utils/object'

export const sendRequestChangePassword = passwordData => {
  return dispatch => {
    userService.changePassword(passwordData)
    .then((userDetails) => {
      if(userDetails.idUser){
        dispatch(tryAutomaticallyLogin())
      }else{
        dispatch(requestFailed({message : 'Token is invalid!'}))
      }
    })
    .catch((err) => {
      dispatch(requestFailed(err + ' Try again.'))
    });
  }
}

export const resetPassword = payload => {
  return dispatch =>{
    userService.resetPassword(payload)
    .then(data => {
      if(data.valid){
        dispatch(tryAutomaticallyLogin())
      }else{
        dispatch(requestFailed(data))
      }
    })
    .catch(err => {
      console.log(err)
    })
  }
}

export function tryAutomaticallyLogin() {
  return async dispatch => {
    dispatch(loggingIn())
    try {
      const response = await loginService.login()
      if (!!objectUtils.get(response, 'idUser', undefined)) {
        dispatch(requestSuccessLogin(response))
      } else {
        dispatch(loggingOut())
      }
    } catch (error) {
      dispatch(loggingOut())
    }
  }
}

const requestSuccessLogin = userDetails => {
  return {
    type: actionTypes.REQUEST_SUCCESS_LOGIN,
    userDetails: userDetails,
  }
}

const loggingIn = () => {
  return {
    type: actionTypes.USER_LOGGING_IN,
  }
}

function loggingOut() {
  return {
    type: actionTypes.USER_LOGGING_OUT,
  }
}


export const onCloseRequestEmailResetPasswordModal = () =>{
  return {
    type: actionTypes.CLOSE_SENT_EMAIL_RESET_PASSWORD_MODAL
  }
}

export const closeResetPasswordModalError = () =>{
  return {
    type : actionTypes.CLOSE_RESET_PASSWORD_MODAL_ERROR
  }
}

const requestFailed = errorMessage => {
  return {
    type: actionTypes.REQUEST_FAILED,
    errorMessage: errorMessage.message
  }
}

export const closeModalFailed = () => {
  return {
    type: actionTypes.CLOSE_MODAL_ERROR
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/Password.js